// prettier-ignore
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ChangeEvent, FunctionComponent, useEffect, useState } from 'react'
import { MdAdd, MdPlayArrow, MdSearch } from 'react-icons/md'
import { Grid } from '@material-ui/core'

import IMotorista from 'modules/motorista/domain/entities/IMotorista'
import IFindFavorecidosContaBancariaResponse from 'modules/pagamentos/domain/entities/IFindFavorecidosContaBancariaResponse'
import { IFindFavorecidosContaBancaria } from 'modules/pagamentos/domain/usecases/FindFavorecidosContaBancaria'
import { IFindFavorecidosTmovPay } from 'modules/pagamentos/domain/usecases/FindFavorecidosTmovPay'
import { NovaContaFactory } from 'modules/pagamentos/factories/NovaConta'
import { useTransferencia } from 'modules/pagamentos/hooks/useTransferencia'
import Autocomplete from 'shared/components/Autocomplete'
import Button from 'shared/components/Button'
import LabelValue from 'shared/components/LabelValue/LabelValue'
import Scaffold from 'shared/components/Scaffold'
import SnackBar from 'shared/components/SnackBar'
import useDebounce from 'shared/hooks/useDebounce'
import { colors } from 'shared/styles/colors'

import { StyledInput } from './styles'
import { useFrotista } from 'modules/user/hooks/useFrotista'
import { IContaPagamentoContraCte } from '../../../../../domain/usecases/ContaPagamentoContraCte'
import IContaPagamentoContraCteResponseDTO from '../../../../../domain/entities/IContaPagamentoContraCteResponseDTO'
import { cpfCnpjMask } from '../../../../../../../shared/utils/formatters'

type TProps = {
  findFavorecidosTmovPay: IFindFavorecidosTmovPay
  findFavorecidosContaBancaria: IFindFavorecidosContaBancaria
  contaPagamentoContraCte: IContaPagamentoContraCte
}

const SelecionarFavorecido: FunctionComponent<TProps> = ({
  findFavorecidosTmovPay,
  findFavorecidosContaBancaria,
  contaPagamentoContraCte,
}) => {
  const {
    handleBackButton,
    setValor,
    setCpf,
    setStep,
    step,
    showNovaConta,
    setShowNovaConta,
    tipoTransferencia,
    contaFavorecido,
    setContaFavorecido,
    setNomeFavorecido,
    setCnpjFavorecido,
    setContaPagamento,
  } = useTransferencia()

  const { frotistaId, frotista } = useFrotista()

  const [filtroInput, setFiltroInput] = useState('')
  const [favorecido, setFavorecido] = useState<IMotorista>({} as IMotorista)
  const [favorecidosList, setFavorecidosList] = useState<
    Array<IMotorista | IContaPagamentoContraCteResponseDTO>
  >([])
  const [contasFavorecidoList, setContasFavorecidoList] = useState([])
  const [valorValue, setValorValue] = useState(0)
  const [loading, setLoading] = useState(false)
  const [openErrorMessage, setOpenErrorMessage] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>('')

  const debouncedFiltro = useDebounce(filtroInput, 1000)

  useEffect(() => {
    if (tipoTransferencia === 'tmov') {
      const init = async () => {
        if (debouncedFiltro && filtroInput) {
          setLoading(true)

          try {
            const response = await findFavorecidosTmovPay.execute({
              filtro: filtroInput,
              frotistaId,
            })
            setLoading(false)
            setFavorecidosList(response)
          } catch (e: unknown) {
            if (e instanceof Error) {
              setErrorMessage(
                e.message ||
                  'Não foi possível encontrar os favorecidos, por favor tente novamente em alguns minutos.',
              )
            } else {
              setErrorMessage(
                'Não foi possível encontrar os favorecidos, por favor tente novamente em alguns minutos.',
              )
            }
            setOpenErrorMessage(true)
            setLoading(false)
          }
        } else {
          setFavorecidosList([])
        }
      }
      init()
    }
  }, [debouncedFiltro, filtroInput, findFavorecidosTmovPay, frotistaId])

  const handleFiltro = (filtro: string) => {
    setFiltroInput(filtro)
  }

  const handleValor = (event: ChangeEvent<HTMLInputElement>) => {
    setValorValue(Number(event.target.value))
  }

  const handleNextButton = () => {
    setValor(valorValue)
    if (tipoTransferencia === 'tmov') {
      setCpf(favorecido?.cpf)
      setNomeFavorecido(favorecido?.nome)
    }
    setStep(step + 1)
  }

  const handleClickNovaConta = () => {
    setShowNovaConta(true)
  }

  const autoCompleteContaBancaria = () => {
    return (
      <Grid>
        <Autocomplete
          label="Buscar contas"
          placeholder="Digite aqui"
          onChange={(
            event: ChangeEvent<HTMLAllCollection>,
            newValue: IFindFavorecidosContaBancariaResponse,
          ) => {
            setContaFavorecido(newValue)
          }}
          inputValue={filtroInput}
          onInputChange={(event, newInputValue) => {
            handleFiltro(newInputValue)
          }}
          options={contasFavorecidoList}
          getOptionLabel={option =>
            `${
              (option as IFindFavorecidosContaBancariaResponse).nome_conta
            } - ${(option as IFindFavorecidosContaBancariaResponse).nome_banco}`
          }
          loading={loading}
          popupIcon={MdSearch}
        />
      </Grid>
    )
  }

  const botaoNovaConta = () => {
    return tipoTransferencia === 'conta' ? (
      <Grid item md={8}>
        <Grid container justifyContent={'flex-end'}>
          <Button color={colors.orange} onClick={handleClickNovaConta}>
            <MdAdd /> Nova Conta
          </Button>
        </Grid>
      </Grid>
    ) : (
      <></>
    )
  }

  const dadosContaBancaria = () => {
    return contaFavorecido?.nome_conta ? (
      <>
        <Grid item xs={12} sm={12} md={6}>
          <LabelValue
            title="Nome da conta:"
            value={contaFavorecido?.nome_conta}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <LabelValue title="Banco:" value={contaFavorecido?.nome_banco} />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <LabelValue
            title="Agencia:"
            value={contaFavorecido?.agencia?.toString()}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <LabelValue
            title="Conta:"
            value={contaFavorecido?.conta?.toString()}
          />
        </Grid>
        <Grid item xs={12}>
          <Grid item xs={12} sm={12} md={3}>
            <Grid item xs={12} sm={12} md={12}>
              <LabelValue title="Valor:" value="" />
              {/* prettier-ignore */}
              <p style={{ margin: 0, height: 30, fontSize: 12, color: '#ff5656'}}>A tarifa de transferencia TED é de R$: 7,90</p>
              <StyledInput
                placeholder="Digite o valor"
                name="valorValue"
                type="number"
                onChange={handleValor}
                label="Valor"
                style={{ marginBottom: 40, marginTop: -10 }}
              />
            </Grid>
          </Grid>
        </Grid>
      </>
    ) : (
      <></>
    )
  }

  const initContaBancaria = async () => {
    setLoading(true)
    try {
      const response = await findFavorecidosContaBancaria.execute(frotistaId)

      if (frotistaId) {
        setCnpjFavorecido(frotista.cnpj)
        setNomeFavorecido(frotista.razao_social)
      }

      setLoading(false)
      setContasFavorecidoList(response)
    } catch (e: unknown) {
      if (e instanceof Error) {
        setErrorMessage(
          e.message ||
            'Não foi possível encontrar as contas do favorecido, por favor tente novamente em alguns minutos.',
        )
      } else {
        setErrorMessage(
          'Não foi possível encontrar as contas do favorecido, por favor tente novamente em alguns minutos.',
        )
      }
      setOpenErrorMessage(true)
      setLoading(false)
    }
  }

  useEffect(() => {
    if (tipoTransferencia === 'conta') {
      initContaBancaria()
    }
  }, [])

  const isNextButtonDisabled = (): boolean => {
    if (tipoTransferencia === 'conta')
      return !contaFavorecido?.nome_conta || valorValue <= 0
    if (tipoTransferencia === 'tmov')
      return !favorecido?.nome || valorValue <= 0
  }

  const controlColorNextButton = (): string => {
    if (tipoTransferencia === 'conta') {
      return contaFavorecido?.nome_conta &&
        valorValue > 0 &&
        tipoTransferencia === 'conta'
        ? colors.green
        : colors.gray
    } else {
      return favorecido?.nome && valorValue > 0 ? colors.green : colors.gray
    }
  }

  const handleBackButtonClearFields = () => {
    setContaFavorecido(null)
    handleBackButton()
  }

  return showNovaConta ? (
    <NovaContaFactory />
  ) : (
    <>
      <Scaffold
        onClickBackButton={handleBackButtonClearFields}
        onClickNextButton={handleNextButton}
        titleBackButton="Voltar"
        titleNextButton="Próximo"
        isNextButtonDisabled={isNextButtonDisabled()}
        showFooterScaffold
        icon={MdPlayArrow}
        color={controlColorNextButton()}
        title="Selecionar favorecido"
      >
        <Grid container spacing={1}>
          <Grid item xs={8} sm={8} md={3}>
            {tipoTransferencia === 'tmov' ? (
              <Autocomplete
                label="Buscar favorecido"
                placeholder="Digite nome, CPF ou CNPJ para buscar"
                onChange={(
                  event: ChangeEvent<HTMLInputElement>,
                  newValue: IMotorista | IContaPagamentoContraCteResponseDTO,
                ) => {
                  setFavorecido(newValue as IMotorista)
                  setCnpjFavorecido((newValue as IMotorista)?.cpf)

                  if (
                    (newValue as IContaPagamentoContraCteResponseDTO)?.documento
                  ) {
                    setContaPagamento(
                      newValue as IContaPagamentoContraCteResponseDTO,
                    )
                    setFavorecido({
                      nome: (newValue as IContaPagamentoContraCteResponseDTO)
                        ?.nome_fantasia,
                      cpf: (newValue as IContaPagamentoContraCteResponseDTO)
                        ?.documento,
                    } as any)
                    setCnpjFavorecido(
                      (newValue as IContaPagamentoContraCteResponseDTO)
                        ?.documento,
                    )
                  } else {
                    setContaPagamento(null)
                  }
                }}
                inputValue={filtroInput}
                onInputChange={(event, newInputValue) => {
                  handleFiltro(newInputValue)
                }}
                options={favorecidosList}
                getOptionLabel={option =>
                  (option as IContaPagamentoContraCteResponseDTO).documento
                    ? `${
                        (option as IContaPagamentoContraCteResponseDTO)
                          .nome_fantasia
                      } - ${
                        (option as IContaPagamentoContraCteResponseDTO)
                          .documento
                      }`
                    : `${(option as IMotorista).nome} - ${
                        (option as IMotorista).cpf
                      }`
                }
                loading={loading}
                popupIcon={MdSearch}
              />
            ) : (
              <>{autoCompleteContaBancaria()}</>
            )}
          </Grid>

          {botaoNovaConta()}

          <SnackBar
            open={openErrorMessage}
            setOpen={setOpenErrorMessage}
            severity="error"
            message={errorMessage}
            horizontal="right"
          />
          <Grid item xs={12} sm={12} md={9} />

          {tipoTransferencia === 'tmov' ? (
            favorecido?.nome && (
              <>
                <Grid item xs={12} sm={12} md={3}>
                  <LabelValue title="Para:" value={favorecido?.nome} />
                </Grid>
                <Grid item xs={12} sm={12} md={3}>
                  <LabelValue
                    title="CPF/CNPJ:"
                    value={cpfCnpjMask(favorecido?.cpf)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Grid item xs={12} sm={12} md={3}>
                    <Grid item xs={12} sm={12} md={12}>
                      <StyledInput
                        placeholder="Digite o valor"
                        name="valorValue"
                        type="number"
                        onChange={handleValor}
                        label={'Valor'}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )
          ) : (
            <>{dadosContaBancaria()}</>
          )}
        </Grid>
      </Scaffold>
    </>
  )
}

export default SelecionarFavorecido
